import React, { useEffect, useState } from "react";
import { supabase } from "./supabase";

export const DraftOrder = ({ sessionId }: { sessionId?: string }) => {
  const [teams, setTeams] = useState<any[]>([]);
  const [totalPicks, setTotalPicks] = useState(0);

  const fetchStatus = async () => {
    if (!sessionId) return;

    const { data: tData } = await supabase
      .from("teams")
      .select("*")
      .order("draft_position", { ascending: true });

    // Count picks ONLY for the current active session
    const { count } = await supabase
      .from("picks")
      .select("*", { count: "exact", head: true })
      .eq("session_id", sessionId);

    if (tData) setTeams(tData);
    if (count !== null) setTotalPicks(count);
  };

  useEffect(() => {
    fetchStatus();

    const channel = supabase
      .channel(`order-sync-${sessionId}`)
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "picks",
          filter: `session_id=eq.${sessionId}`,
        },
        () => fetchStatus()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [sessionId]);

  // Hide the order if no teams exist or if we've reached the draft limit (e.g., 22 rounds x 4 teams = 88)
  if (!sessionId || teams.length === 0 || totalPicks >= 88) return null;

  // Calculate the next 5 teams in the rotation based on current session progress
  const nextPicks = Array.from({ length: 5 }, (_, i) => {
    const globalIndex = totalPicks + i;
    const teamIndex = globalIndex % teams.length;
    return {
      pickNum: globalIndex + 1,
      round: Math.floor(globalIndex / teams.length) + 1,
      team: teams[teamIndex],
    };
  });

  return (
    <div
      style={{
        background: "#151513",
        borderLeft: "4px solid #22565a",
        padding: "20px",
        borderRadius: "0 8px 8px 0",
        marginBottom: "30px",
        fontFamily: "'Oswald', sans-serif",
      }}
    >
      <h4
        style={{
          color: "#22565a",
          margin: "0 0 15px 0",
          fontSize: "0.8rem",
          letterSpacing: "2px",
          textTransform: "uppercase",
        }}
      >
        DRAFT ORDER
      </h4>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {nextPicks.map((p, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              opacity: idx === 0 ? 1 : 0.6 - idx * 0.1, // Fades the further out they are
              borderBottom: "1px solid #222",
              paddingBottom: "8px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span
                style={{
                  color: "#444",
                  fontWeight: "bold",
                  fontSize: "0.75rem",
                }}
              >
                #{p.pickNum}
              </span>
              <span
                style={{
                  color: idx === 0 ? "#f9eeda" : "#888",
                  fontWeight: idx === 0 ? "bold" : "normal",
                  fontSize: idx === 0 ? "1.1rem" : "0.95rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {p.team.team_name}
              </span>
            </div>
            <span
              style={{
                color: "#22565a",
                fontSize: "0.75rem",
                fontWeight: 600,
              }}
            >
              RD {p.round}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
